<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <h3>{{data.fullName ? data.fullName : ('Delete ' + data.name)}}</h3>
  </div>

  <span class="close-dialog" (click)="noDelete()">
      <i class="material-icons">close</i>
  </span>
</div>

  <div mat-dialog-content>
    <ng-container *ngIf="data?.infoTooltip; else defaultContent">
      <p class="confirm-text">
        <span>{{ data.content ? data.content : ('Are you sure you want to delete the selected ' + data.name) }}</span
        ><span>{{data.removeQuestionMark ? '' : '?'}}</span>
        <i
          class="material-icons ml-10 info-icon"
          [matTooltip]="data.infoTooltip"
          matTooltipPosition="below"
          aria-label="Info">info</i>
        <span *ngIf="data.body"><br>{{data.body}}</span>
      </p>
    </ng-container>

    <ng-template #defaultContent>
      <p [innerHTML]="(data.content ? data.content : ('Are you sure you want to delete the selected ' + data.name))
                     + (data.removeQuestionMark ? '' : '?') + (data.body ? '<br>' + data.body : '')">
      </p>
    </ng-template>
  </div>
<div class="footer-modal footer-modal--center mt-20">
  <cmp-button *ngIf="data.addCancelBtn !== false" [class]="'cancel mr-20'" [text]="data.changeButtonLabels ? 'No' : 'Cancel'"  (click)="noDelete()"></cmp-button>
  <cmp-button *ngIf="data.removeSaveBtn !== true" [class]="(data?.type || 'Delete')  === 'Delete' ? 'danger' : 'primary'" (click)="delete()"
              [text]="data?.type || 'Delete'"></cmp-button>
</div>
